import { useId, type ReactNode } from 'react'
import * as LabelPrimitive from '@radix-ui/react-label'
import { cn } from '@/lib/utils'
import { Checkbox } from '@/design-system/components/primitives/checkbox'

/**
 * Чекбокс с подписью (паттерн SettingRow): подпись связана с контролом через htmlFor/id,
 * клик по тексту переключает. Используется в формах визарда СОУТ (председатель, ПД, флаги места).
 */
export interface LabeledCheckboxProps {
  checked: boolean
  disabled?: boolean
  onCheckedChange: (checked: boolean) => void
  children: ReactNode
  /** Выравнивание для многострочной подписи (ПД-согласие). */
  align?: 'center' | 'start'
  className?: string
}

export function LabeledCheckbox({
  checked,
  disabled,
  onCheckedChange,
  children,
  align = 'center',
  className,
}: LabeledCheckboxProps) {
  const id = useId()
  return (
    <div
      className={cn(
        'flex gap-2.5 text-14 text-txt',
        align === 'start' ? 'items-start' : 'items-center',
        className,
      )}
    >
      <Checkbox
        id={id}
        checked={checked}
        disabled={disabled}
        onCheckedChange={(value) => onCheckedChange(value === true)}
        className={align === 'start' ? 'mt-0.5' : undefined}
      />
      <LabelPrimitive.Root htmlFor={id}>{children}</LabelPrimitive.Root>
    </div>
  )
}
